import React from "react";
import "./style.css";

// Header component
const Header = props => {
  return (
    <div className="header ">
      <div className="container">
        <h1 className="header__title">{props.title}</h1>
        {props.subtitle && (
          <h2 className="header__subtitle">{props.subtitle}</h2>
        )}
      </div>
    </div>
  );
};

Header.defaultProps = {
  title: "To-Do App"
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js